import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { api } from 'common';
import { Alert, Box, Tab, Tabs } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import DriverEarning from './DriverEarning';
import Earningreports from './Earningreports';
import FleetAdminEarning from './FleetAdminEarning';
import NetworkLevelReport from '../components/reports/NetworkLevelReport';
import { C2SecondaryButton } from '../components/C2Dialog';
import { C2_FONT, c2PillTabsSx, c2TableTheme } from '../components/Table/C2UserTable';

export default function AllReports() {
  const usertype = useSelector((state) => state.auth.profile?.usertype);
  const isAdmin = usertype === 'admin';
  const [tab, setTab] = useState('network');
  const [bookings, setBookings] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const tabs = isAdmin
    ? [
        { value: 'network', label: 'Red por niveles' },
        { value: 'drivers', label: 'Conductores' },
        { value: 'platform', label: 'Plataforma' },
        { value: 'fleets', label: 'Flotas' },
      ]
    : [{ value: 'drivers', label: 'Conductores' }];
  const activeTab = tabs.some((t) => t.value === tab) ? tab : tabs[0].value;
  const needsBookings = activeTab !== 'network';

  const loadBookings = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setBookings(await api.fetchReportBookings());
    } catch (e) {
      setBookings((cur) => cur || []);
      setError('No se pudieron cargar las reservas para los reportes.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (needsBookings && bookings === null && !loading) loadBookings();
  }, [needsBookings, bookings, loading, loadBookings]);

  const panelProps = { bookings: bookings || [], loading: loading && bookings === null };

  return (
    <ThemeProvider theme={c2TableTheme}>
      <Box sx={{ width: '100%', fontFamily: C2_FONT }}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 1.5, mb: 2 }}>
          <Tabs value={activeTab} onChange={(e, v) => setTab(v)} variant="scrollable" scrollButtons="auto" sx={c2PillTabsSx}>
            {tabs.map((t) => (
              <Tab key={t.value} value={t.value} label={t.label} />
            ))}
          </Tabs>
          {needsBookings ? (
            <C2SecondaryButton startIcon={<RefreshRoundedIcon />} onClick={loadBookings} disabled={loading}>
              {loading ? 'Actualizando…' : 'Actualizar datos'}
            </C2SecondaryButton>
          ) : null}
        </Box>

        {error && needsBookings ? (
          <Alert severity="error" sx={{ mb: 2, borderRadius: '12px', fontFamily: C2_FONT }}>
            {error}
          </Alert>
        ) : null}

        {activeTab === 'network' ? <NetworkLevelReport /> : null}
        {activeTab === 'drivers' ? <DriverEarning {...panelProps} /> : null}
        {activeTab === 'platform' ? <Earningreports {...panelProps} /> : null}
        {activeTab === 'fleets' ? <FleetAdminEarning {...panelProps} /> : null}
      </Box>
    </ThemeProvider>
  );
}
